(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // Testimonial carousel (phone and tablet): scroll-snap plus the two arrows.
  // Scoped to sections that opted in; no-ops everywhere else.
  class TestimonialsCarousel {
    constructor(root) {
      this.track = root.querySelector('.testimonials__grid--carousel');
      this.prev = root.querySelector('.testimonials__arrow--prev');
      this.next = root.querySelector('.testimonials__arrow--next');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();

      // Start on the middle card
      const slides = this.slides();
      if (slides.length > 2) this.scrollTo(slides[Math.floor(slides.length / 2)]);
    }

    slides() {
      return Array.from(this.track.children);
    }

    scrollTo(el) {
      if (!el) return;
      this.track.scrollTo({ left: el.offsetLeft - (this.track.clientWidth - el.clientWidth) / 2, behavior: 'smooth' });
    }

    step(dir) {
      const slides = this.slides();
      const w = this.track.clientWidth || 1;
      const i = Math.round(this.track.scrollLeft / w);
      this.scrollTo(slides[Math.min(slides.length - 1, Math.max(0, i + dir))]);
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  const initTestimonials = () => {
    document.querySelectorAll('.testimonials__viewport:has(.testimonials__grid--carousel)').forEach((root) => {
      if (root.dataset.carouselReady) return;
      root.dataset.carouselReady = 'true';
      new TestimonialsCarousel(root);
    });
  };

  document.addEventListener('DOMContentLoaded', initTestimonials);
  document.addEventListener('shopify:section:load', initTestimonials);
  initTestimonials();

  } catch(e) { console.error(e); }
})();
})();
